import { paymentService } from "Network/lib/paymentService";
import vehicleSummaryService from "Network/lib/vehicleSummaryService";

import * as actionTypes from "./actionTypes";

export const fetchSummaryRequestStart = () => ({
  type: actionTypes.FETCH_SUMMARY_START
});

export const fetchSummaryRequestSuccess = (data) => ({
  type: actionTypes.FETCH_SUMMARY_SUCCESS,
  data
});

export const fetchSummaryRequestFail = (error) => ({
  type: actionTypes.FETCH_SUMMARY_FAIL,
  error
});

export const updateRefurbEstimateDateInStore = (refurbEstimateDate) => ({
  type: actionTypes.UPDATE_REFURB_ESTIMATE_DATE,
  refurbEstimateDate
});

export const fetchSummary = (leadId) => (dispatch) => {
  dispatch(fetchSummaryRequestStart());
  return vehicleSummaryService
    .fetchVehicleDetails(leadId)
    .then((response) => {
      dispatch(fetchSummaryRequestSuccess(response));
      return Promise.resolve(response);
    })
    .catch((err) => {
      dispatch(fetchSummaryRequestFail(err.response?.data?.error));
      return Promise.reject(err);
    });
};

export const setCurrentCardStep = (step) => ({
  type: actionTypes.SET_CURRENT_CARD_STEP,
  step
});

export const downloadAttachmentsStart = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_START
});

export const downloadAttachmentsSuccess = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_SUCCESS
});

export const downloadAttachmentsFail = () => ({
  type: actionTypes.DOWNLOAD_ATTACHMENT_FAIL
});

export const fetchPaymentDetailsStart = () => ({
  type: actionTypes.FETCH_PAYMENT_DETAILS_START
});

export const fetchPaymentDetailsSuccess = (paymentDetails) => ({
  type: actionTypes.FETCH_PAYMENT_DETAILS_SUCCESS,
  data: paymentDetails
});

export const fetchPaymentDetailsFail = (error) => ({
  type: actionTypes.FETCH_PAYMENT_DETAILS_FAIL,
  error
});

export const modifyPaymentStatusStart = () => ({
  type: actionTypes.MODIFY_PAYMENT_STATUS_START
});

export const modifyPaymentStatusSuccess = (payload) => ({
  type: actionTypes.MODIFY_PAYMENT_STATUS_SUCCESS,
  data: payload
});

export const modifyPaymentStatusFail = (error) => ({
  type: actionTypes.MODIFY_PAYMENT_STATUS_FAIL,
  error
});

export const downloadAttachments = (fileName, name) => {
  const downloadFileName = name.substr(0, name.indexOf("."));

  return (dispatch) => {
    dispatch(downloadAttachmentsStart());
    vehicleSummaryService
      .downloadAttachments(fileName)
      .then((response) => {
        const blob = new Blob([response], {
          type: "application/pdf"
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = `${downloadFileName}.pdf`;
        a.click();
        dispatch(downloadAttachmentsSuccess());
      })
      .catch((error) => {
        console.error(error);
        dispatch(downloadAttachmentsFail());
      });
  };
};

const fetchDataValidationStart = () => ({
  type: actionTypes.FETCH_DATA_VALIDATION_START
});
const fetchDataValidationSuccess = (data) => ({
  type: actionTypes.FETCH_DATA_VALIDATION_SUCCESS,
  data
});
const fetchDataValidationFail = () => ({
  type: actionTypes.FETCH_DATA_VALIDATION_FAIL
});

export const fetchDataValidation = (appId) => (dispatch) => {
  dispatch(fetchDataValidationStart());

  vehicleSummaryService
    .getDataValidation(appId)
    .then((response) => dispatch(fetchDataValidationSuccess(response)))
    .catch((err) => {
      dispatch(fetchDataValidationFail(err));
    });
};

const postDataValidationStart = () => ({
  type: actionTypes.POST_DATA_VALIDATION_START
});

const postDataValidationFail = () => ({
  type: actionTypes.POST_DATA_VALIDATION_FAIL
});

export const postDataValidation = (appId, payload) => (dispatch) => {
  dispatch(postDataValidationStart());
  return new Promise((resolve, reject) => {
    vehicleSummaryService
      .postDataValidation(appId, payload)
      .then((resp) => resolve(resp))
      .catch((err) => {
        reject(err);
        dispatch(postDataValidationFail());
      });
  });
};

export const syncEEData = (appId, isRefreshNvicTrue) => (dispatch) =>
  new Promise((resolve, reject) => {
    vehicleSummaryService
      .syncEEData(appId, isRefreshNvicTrue)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const PhotographyQcComplete = (appId) => (dispatch) =>
  new Promise((resolve, reject) => {
    vehicleSummaryService
      .photographyQcComplete(appId)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });

export const updateVehicleSegment = (appointmentId) => (dispatch) =>
  new Promise((resolve, reject) => {
    vehicleSummaryService
      .updateVehicleSegment(appointmentId)
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getServiceHistoryStart = () => ({
  type: actionTypes.FETCH_SERVICE_HISTORY_START
});
const getServiceHistorySuccess = (data) => ({
  type: actionTypes.FETCH_SERVICE_HISTORY_SUCCESS,
  data
});
const getServiceHistoryFail = () => ({
  type: actionTypes.FETCH_SERVICE_HISTORY_FAIL
});

export const getServiceHistory = (appId) => (dispatch) => {
  dispatch(getServiceHistoryStart());

  vehicleSummaryService
    .getServiceHistory(appId)
    .then((response) => dispatch(getServiceHistorySuccess(response)))
    .catch((err) => dispatch(getServiceHistoryFail(err)));
};

const fetchWarrantyStart = () => ({
  type: actionTypes.FETCH_WARRANTY_START
});

const fetchWarrantySuccess = (data) => ({
  type: actionTypes.FETCH_WARRANTY_SUCCESS,
  data
});

const fetchWarrantyFail = () => ({
  type: actionTypes.FETCH_WARRANTY_FAIL
});

export const fetchWarranty = (appointmentId) => async (dispatch) => {
  dispatch(fetchWarrantyStart());
  try {
    const data = await vehicleSummaryService.fetchWarrantyDetails(appointmentId);
    dispatch(fetchWarrantySuccess(data));
  } catch (error) {
    dispatch(fetchWarrantyFail(error));
  }
};

const postWarrantyStart = () => ({
  type: actionTypes.POST_WARRANTY_START
});
const postWarrantySuccess = () => ({
  type: actionTypes.POST_WARRANTY_SUCCESS
});
const postWarrantyFail = () => ({
  type: actionTypes.POST_WARRANTY_FAIL
});

export const postWarranty = (payload) => async (dispatch) => {
  dispatch(postWarrantyStart());

  try {
    const updatedData = await vehicleSummaryService.updateWarranty(payload);
    dispatch(postWarrantySuccess());
    return Promise.resolve(updatedData);
  } catch (error) {
    dispatch(postWarrantyFail());
    return Promise.reject(error);
  }
};

const getHoldsStart = () => ({
  type: actionTypes.FETCH_HOLDS_START
});
const getHoldsSuccess = (data) => ({
  type: actionTypes.FETCH_HOLDS_SUCCESS,
  data
});
const getHoldsFail = () => ({
  type: actionTypes.FETCH_HOLDS_FAIL
});

export const getHolds = (appointmentId) => async (dispatch) => {
  dispatch(getHoldsStart());

  try {
    const data = await vehicleSummaryService.getHolds(appointmentId, true);
    dispatch(getHoldsSuccess(data));
  } catch (error) {
    dispatch(getHoldsFail(error));
  }
};

const getInActiveHoldsStart = () => ({
  type: actionTypes.FETCH_INACTIVE_HOLDS_START
});
const getInActiveHoldsSuccess = (data) => ({
  type: actionTypes.FETCH_INACTIVE_HOLDS_SUCCESS,
  data
});
const getInActiveHoldsFail = () => ({
  type: actionTypes.FETCH_INACTIVE_HOLDS_FAIL
});

export const getInActiveHolds = (appointmentId) => async (dispatch) => {
  dispatch(getInActiveHoldsStart());

  try {
    const data = await vehicleSummaryService.getHolds(appointmentId, false);
    dispatch(getInActiveHoldsSuccess(data));
  } catch (error) {
    dispatch(getInActiveHoldsFail(error));
  }
};

const addHoldsStart = () => ({
  type: actionTypes.ADD_HOLDS_START
});
const addHoldsSuccess = () => ({
  type: actionTypes.ADD_HOLDS_SUCCESS
});
const addHoldsFail = () => ({
  type: actionTypes.ADD_HOLDS_FAIL
});

export const addHolds = (payload) => async (dispatch) => {
  dispatch(addHoldsStart());

  try {
    const data = await vehicleSummaryService.addHolds(payload);
    dispatch(addHoldsSuccess());
    return Promise.resolve(data);
  } catch (error) {
    dispatch(addHoldsFail());
  }
};

const fetchPricingStart = () => ({
  type: actionTypes.FETCH_PRICING_START
});
const fetchPricingSuccess = (data) => ({
  type: actionTypes.FETCH_PRICING_SUCCESS,
  data
});
const fetchPricingFail = () => ({
  type: actionTypes.FETCH_PRICING_FAIL
});

export const fetchPricing = (appointmentId, pageSize) => async (dispatch) => {
  dispatch(fetchPricingStart());

  try {
    const data = await vehicleSummaryService.getPrice(appointmentId, pageSize);
    dispatch(fetchPricingSuccess(data));
  } catch (error) {
    dispatch(fetchPricingFail());
  }
};

const fetchPricingModalStart = () => ({
  type: actionTypes.FETCH_PRICING_MODAL_START
});
const fetchPricingModalSuccess = (data) => ({
  type: actionTypes.FETCH_PRICING_MODAL_SUCCESS,
  data
});
const fetchPricingModalFail = () => ({
  type: actionTypes.FETCH_PRICING_MODAL_FAIL
});

export const fetchPricingModal = (appointmentId, pageSize) => async (dispatch) => {
  dispatch(fetchPricingModalStart());

  try {
    const data = await vehicleSummaryService.getPrice(appointmentId, pageSize);
    dispatch(fetchPricingModalSuccess(data));
  } catch (error) {
    dispatch(fetchPricingModalFail());
  }
};

const getCheckListStart = () => ({
  type: actionTypes.FETCH_PUBLISHING_CHECKLIST_START
});
const getCheckListSuccess = (data) => ({
  type: actionTypes.FETCH_PUBLISHING_CHECKLIST_SUCCESS,
  data
});
const getCheckListFail = () => ({
  type: actionTypes.FETCH_PUBLISHING_CHECKLIST_FAIL
});

export const getCheckList = (appointmentId) => async (dispatch) => {
  dispatch(getCheckListStart());

  try {
    const data = await vehicleSummaryService.getChecklist(appointmentId);
    dispatch(getCheckListSuccess(data));
  } catch (error) {
    dispatch(getCheckListFail(error));
  }
};

const getMarketplaceStart = () => ({
  type: actionTypes.FETCH_MARKETPLACE_START
});

const getMarketplaceSuccess = (data) => ({
  type: actionTypes.FETCH_MARKETPLACE_SUCCESS,
  data
});

const getMarketplaceFail = () => ({
  type: actionTypes.FETCH_MARKETPLACE_FAIL
});

export const fetchMarketplace = (appointmentId) => async (dispatch) => {
  dispatch(getMarketplaceStart());
  try {
    const data = await vehicleSummaryService.getMarketplaceData(appointmentId);
    dispatch(getMarketplaceSuccess(data));
  } catch (error) {
    dispatch(getMarketplaceFail(error));
  }
};

const fetchRecallTabStart = () => ({
  type: actionTypes.FETCH_RECALL_TAB_START
});

const fetchRecallTabSuccess = (data) => ({
  type: actionTypes.FETCH_RECALL_TAB_SUCCESS,
  data
});

const fetchRecallTabFail = () => ({
  type: actionTypes.FETCH_RECALL_TAB_FAIL
});

export const fetchRecallTab = (leadId, isActive) => async (dispatch) => {
  dispatch(fetchRecallTabStart());
  try {
    const data = await vehicleSummaryService.getRecallTab(leadId, isActive);
    dispatch(fetchRecallTabSuccess(data));
  } catch (error) {
    dispatch(fetchRecallTabFail(error));
  }
};

export function fetchReviewTab(appId) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_REVIEW_TAB_DETAILS_START });
    try {
      const response = await vehicleSummaryService.fetchReviewTab(appId);
      dispatch({ type: actionTypes.FETCH_REVIEW_TAB_DETAILS_SUCCESS, data: response });
    } catch (error) {
      dispatch({ type: actionTypes.FETCH_REVIEW_TAB_DETAILS_FAIL, error });
    }
  };
}

export function fetchSoldQCDetails(leadId) {
  return async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_SOLD_QC_DETAILS_REQUEST });

    try {
      const response = await vehicleSummaryService.fetchSoldQCDetails(leadId);
      dispatch({ type: actionTypes.FETCH_SOLD_QC_DETAILS_SUCCESS, data: response });
    } catch (error) {
      dispatch({ type: actionTypes.FETCH_SOLD_QC_DETAILS_FAILURE, error });
    }
  };
}

export const fetchVideographyPremiumFeaturesTag = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_REQUEST });

  try {
    const response = await vehicleSummaryService.fetchVideographyPremiumFeaturesTag(appointmentId);
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_FAILURE, error });
  }
};

export const fetchVideographyPrompt = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PROMPT_REQUEST });

  try {
    const response = await vehicleSummaryService.fetchVideographyPrompt(appointmentId);
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PROMPT_SUCCESS, data: response });
  } catch (error) {
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_PROMPT_FAILURE, error });
  }
};

export const updateVideographyPrompt = (appointmentId, payload) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_REQUEST });

  try {
    const response = await vehicleSummaryService.updateVideographyPrompt(appointmentId, payload);
    dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_FAILURE, error });
    return Promise.reject(error);
  }
};

export const fetchVideographyWorkstationDetails = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_REQUEST });

  try {
    const response = await vehicleSummaryService.fetchVideographyWorkstationDetails(appointmentId);
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_FAILURE, error });
  }
};

export const setVideographyQcActionType = (actionType) => (dispatch) => {
  dispatch({ type: actionTypes.SET_VIDEOGRAPHY_QC_ACTION_TYPE, data: actionType });
};

export const fetchProcessTrackerDetails = (trackerId) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_PROCESS_TRACKER_DETAILS_REQUEST });

  try {
    const response = await vehicleSummaryService.fetchProcessTrackerDetails(trackerId);
    dispatch({ type: actionTypes.FETCH_PROCESS_TRACKER_DETAILS_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.FETCH_PROCESS_TRACKER_DETAILS_FAILURE, error });
    return Promise.reject(error);
  }
};

export const setAudioNodeProcessTracker = (jobId) => (dispatch) => {
  dispatch({ type: actionTypes.SET_AUDIO_NODE_PROCESS_TRACKER, currentAudio: jobId });
};

export const resetPocessTrackerDetails = () => (dispatch) => {
  dispatch({ type: actionTypes.RESET_PROCESS_TRACKER_DETAILS });
};

export const completeVideographyQcAction = (appointmentId, action, jobId) => async (dispatch) => {
  dispatch({ type: actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_REQUEST });

  try {
    const response = await vehicleSummaryService.completeVideographyQcAction(appointmentId, action, jobId);
    dispatch({ type: actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_FAILURE, error });
    return Promise.reject(error);
  }
};

export const updateVideographyWorkstationData = (appointmentId, payload) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_REQUEST });

  try {
    const response = await vehicleSummaryService.updateVideographyWorkstationData(appointmentId, payload);
    dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_FAILURE, error });
    return Promise.reject(error);
  }
};

export const resetFinalVideoExtraction = () => (dispatch) => {
  dispatch({ type: actionTypes.RESET_FINAL_VIDEO_EXTRACTION });
};

export const resetFinalVideoDetails = () => (dispatch) => {
  dispatch({ type: actionTypes.RESET_FINAL_VIDEO_DETAILS });
};

export const fetchVideographyFinalVideoDetails = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST });

  try {
    const response = await vehicleSummaryService.fetchVideographyFinalVideoDetails(appointmentId);
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS, data: response });
  } catch (error) {
    dispatch({ type: actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE, error });
  }
};

export const updateVideographyFinalVideoDetails =
  ({ payload, isReupload, assetUpdate }) =>
  async (dispatch) => {
    dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST });

    try {
      const response = await vehicleSummaryService.updateVideographyFinalVideoDetails(payload, isReupload, assetUpdate);
      dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS, data: response });
      return Promise.resolve(response);
    } catch (error) {
      dispatch({ type: actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE, error });
      return Promise.reject(error);
    }
  };

export const uploadFinalVideoPlatform = (payload) => async (dispatch) => {
  dispatch({ type: actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_REQUEST });

  try {
    const response = await vehicleSummaryService.uploadFinalVideoPlatform(payload);
    dispatch({ type: actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_FAILURE, error });
    return Promise.reject(error);
  }
};

export const checkFinalVideoPlatformStatus = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_REQUEST });

  try {
    const response = await vehicleSummaryService.checkFinalVideoPlatformStatus(appointmentId);
    dispatch({ type: actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_FAILURE, error });
    return Promise.reject(error);
  }
};

export const generateFinalVideoChapterGif = (appointmentId, chapterId) => async (dispatch) => {
  dispatch({ type: actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_REQUEST });

  try {
    const response = await vehicleSummaryService.generateFinalVideoChapterGif(appointmentId, chapterId);
    dispatch({ type: actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_FAILURE, error });
    return Promise.reject(error);
  }
};

export const publishFinalVideo = (appointmentId) => async (dispatch) => {
  dispatch({ type: actionTypes.PUBLISH_FINAL_VIDEO_REQUEST });

  try {
    const response = await vehicleSummaryService.publishFinalVideo(appointmentId);
    dispatch({ type: actionTypes.PUBLISH_FINAL_VIDEO_SUCCESS, data: response });
    return Promise.resolve(response);
  } catch (error) {
    dispatch({ type: actionTypes.PUBLISH_FINAL_VIDEO_FAILURE, error });
    return Promise.reject(error);
  }
};

export const toggleVideographyConfirmModal = (val) => (dispatch) => {
  dispatch({ type: actionTypes.TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL, isOpen: val });
};

export const setVideographyConfirmModal = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.SET_VIDEOGRAPHY_CONFIRM_MODAL, data: payload });
};

export const toggleVideographyConfirmModalLoading = (isLoading) => (dispatch) => {
  dispatch({ type: actionTypes.TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL_LOADING, isLoading });
};

export const toggleVideographyUploadModal = (val) => (dispatch) => {
  dispatch({ type: actionTypes.TOGGLE_VIDEOGRAPHY_UPLOAD_MODAL, isOpen: val });
};

export const setVideographyUploadModal = (payload) => (dispatch) => {
  dispatch({ type: actionTypes.SET_VIDEOGRAPHY_UPLOAD_MODAL, data: payload });
};

export const setVideographyUploadStatus = (val) => (dispatch) => {
  dispatch({ type: actionTypes.SET_VIDEOGRAPHY_UPLOAD_STATUS, isUploadSuccess: val });
};

export const fetchPaymentDetails = (id) => async (dispatch) => {
  dispatch(fetchPaymentDetailsStart());

  try {
    const response = await paymentService.fetchPaymentDetails(id);
    dispatch(fetchPaymentDetailsSuccess(response));
    return Promise.resolve(response);
  } catch (error) {
    dispatch(dispatch(fetchPaymentDetailsFail(error)));
    return Promise.reject(error);
  }
};

export const modifyPaymentStatus = (data) => async (dispatch) => {
  dispatch(modifyPaymentStatusStart());

  try {
    const response = await paymentService.modifyPaymentStatus(data);
    dispatch(modifyPaymentStatusSuccess(response));
    return Promise.resolve(response);
  } catch (error) {
    dispatch(dispatch(modifyPaymentStatusFail(error)));
    return Promise.reject(error);
  }
};

export const fetchDownloadLink = (path) => () =>
  new Promise((resolve, reject) => {
    paymentService
      .fetchDownloadLink(path)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const stitchFinalVideo = (appointmentId) => async () => {
  try {
    const response = await vehicleSummaryService.stitchFinalVideo(appointmentId);
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const checkFinalVideoStitchStatus = (appointmentId) => async () => {
  try {
    const response = await vehicleSummaryService.checkFinalVideoStitchStatus(appointmentId);
    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
};
